module.exports = __WEBPACK_EXTERNAL_MODULE_3__;


//////////////////
// WEBPACK FOOTER
// external {"root":"mobx-react","commonjs2":"mobx-react","commonjs":"mobx-react","amd":"mobx-react"}
// module id = 3
// module chunks = 0